import { dump } from "js-yaml";

// JavaScript Document
// [PC]求人詳細画面 : 画面下部に固定表示される「問い合わせボタン」と「〇人がこの求人をみています」の表示・非表示を制御する
// .no_m3p-fixedbnr_area_top, .no_m3p-fixedbnr_area_bottom に挟まれているエリアが画面内に表示されている場合は、非表示にする
// 
// HACK: 初期表示の際に、フッターがちらつくことを防ぐために、showFlag の値を floating-footer の visibility と初期値を合わせること！

(function ($) {
  $(function () {
    // アニメーションの秒数
    var animateDuration = 200; // [ms]

    // footer
    var floatingFooter = $('.floating-footer');

    // フッター表示禁止エリア
    var forbiddenAreaTop = $('.no_m3p-fixedbnr_area_top');
    var forbiddenAreaBottom = $('.no_m3p-fixedbnr_area_bottom');

    // 表示フラグ
    var showFlag = false;

    // 初期表示
    updateFloatingFootersBottom(true);

    $(window).scroll(function () {      
      updateFloatingFootersBottom(true)
    });

    // フッターの表示・非表示を更新するメソッド
    // animate: Boolean
    // 以下の変数を更新する
    // * showFlag
    // * floatingFooter の css
    function updateFloatingFootersBottom(animate) {
      var newShowFlag = isShowable(forbiddenAreaTop.offset().top, forbiddenAreaBottom.offset().top)

      if (newShowFlag === showFlag) { return }

      showFlag = newShowFlag

      if (newShowFlag) {
        showAnimate(floatingFooter, animate);
      } else {
        hideAnimate(floatingFooter, animate);
      }
    }

    // フッター表示禁止エリアが、画面内に表示されているかどうかを返す
    // topPosition: Float フッター表示禁止エリアの top
    // bottomPosition: Float フッター表示禁止エリアの bottom
    function isShowable(topPosition, bottomPosition) {
      var scrollTop = $(window).scrollTop();
      var scrollBottom = scrollTop + $(window).height();

      // AtlasフッターのアプリDL表示箇所の高さを算出する
      var atlasFooterHeight = $('.atlas-footer').height() ?? 0;
      var atlasFooterBottomHeight = $('.atlas-footer__bottom').height() ?? 0;
      var atlasFooterAppHeight = atlasFooterHeight - atlasFooterBottomHeight;

      return scrollBottom < topPosition || scrollTop > (bottomPosition + atlasFooterAppHeight)
    }

    function getShowingStyle(_floatingFooter) { return { bottom: '0px' } };
    function getHidingStyle(floatingFooter){ return { bottom: `-${floatingFooter.outerHeight()}px` } };

    // floatingFooter の表示・非表示アニメーション
    function showAnimate(floatingFooter, animate) {
      var showingStyle = getShowingStyle();
      var hidingStyle = getHidingStyle(floatingFooter);

      floatingFooter.css(hidingStyle)
      floatingFooter.css('visibility','visible' );

      if (animate) {
        floatingFooter.stop().animate(showingStyle, animateDuration);
      } else {
        floatingFooter.css(showingStyle)
      }
    }

    function hideAnimate(floatingFooter, animate) {
      var hidingStyle = getHidingStyle(floatingFooter);
      var showingStyle = getShowingStyle();

      var completion = function(){
        floatingFooter.css('visibility','hidden' );
      };

      floatingFooter.css(showingStyle)

      if (animate) {
        floatingFooter.stop().animate(hidingStyle, animateDuration, completion);
      } else {
        floatingFooter.css(hidingStyle)
        completion();
      }
    }
  });
})(jQuery);